import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import { BooleanField, DateField } from "react-admin";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import { settings } from "app";
import { MobileListRow } from "features/MobileListRow";
import UpdateAccreditationExpiryDateDialog from "./UpdateAccreditationExpiryDateDialog";
import AddSpecializationsDialog from "./AddSpecializationsDialog";

const SpecializationsMobileExpanded = ({ record }) => {
  if (!record?.specializations?.length) return null;

  return (
    <Accordion sx={{ width: "100%" }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: "#4E2683" }} />}>
        <Typography sx={{ fontWeight: "bold" }}>Детайли</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ width: "100%" }}>
        {record.specializations.map((item, idx) => (
          <div
            key={item?.specializationId ?? idx}
            style={settings.style.shadowBoxMobile}
          >
            <MobileListRow fields={[{ label: "Специалност (БГ)", value: item.specializationNameBg }]} />
            <MobileListRow fields={[{ label: "Специалност (EN)", value: item.specializationNameEn }]} />
            <MobileListRow
              fields={[
                {
                  label: "Изтичане на акредитация",
                  value: (
                    <DateField
                      source="accreditationExpiryDate"
                      record={item}
                      locales="bg-BG"
                    />
                  ),
                },
              ]}
            />
            <MobileListRow
              fields={[
                {
                  label: "Изтекла акредитация",
                  value: (
                    <BooleanField
                      source="isExpired"
                      record={item}
                    />
                  ),
                },
              ]}
            />
            <SecuredComponent permission={permissions.canManageSpecialistsTrainingBuildings}>
              <UpdateAccreditationExpiryDateDialog
                buildingId={record.buildingId}
                specializationId={item?.specializationId}
              />
            </SecuredComponent>
          </div>
        ))}
        <SecuredComponent permission={permissions.canManageSpecialistsTrainingBuildings}>
          <AddSpecializationsDialog
            buildingId={record.buildingId}
            specializations={record.specializations}
          />
        </SecuredComponent>
      </AccordionDetails>
    </Accordion>
  );
};

export default SpecializationsMobileExpanded;
